module.exports = __webpack_public_path__ + "static/media/guide-line-09.7175f3d4.svg";